<template>
<div>
    <navi selectedid="tlMediaCenter"></navi>
    <subNavi selectedid="tlInteraction" lastrouter="/media/video" nextrouter="/media/news"></subNavi>
    
    <div id="Contents">
        <!-- <div id="Logo">
            <h1 title="Arivo Tyre"><img src="../../common/images/common/logo.png" alt="Arivo Tyre" width="229" height="42"></h1>
            <h2 title="HOME"><a href="../index.html" title="HOME"><img src="../../common/images/top/home.png" alt="HOME" width="229" height="219"></a></h2>

            <siteMenu></siteMenu>
        </div> -->
        <logo selectedid="tlMediaCenter"></logo>

        <spNavi selectedid="tlInteraction"></spNavi>

        <div id="Main">
            <div class="media-article">
                <div class="video-container">
                    <div class="video-item" v-for="item in videos">
                        <video controls="controls" v-bind:poster="item.image" width="30%" height="100px" title="Test">
                        <source v-bind:src="item.file" type="video/mp4">
                        </video>
                        <span>{{item.title}}</span>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>
            <div class="media--reviews">
              <div class="ttl">{{$t("lbGlobalComment")}}</div>
              <ul>
                  <li v-for="comment in comments">
                      <div class="comment-left">
                          <img :src="comment.user_image"><br/>
                          <span>{{comment.user_name}}</span>
                      </div>
                      <div class="comment-right">
                        <div class="clear"></div>
                        <div class="comment-body">{{comment.content}}</div><br/>
                        <div class="comment-date">{{comment.published_date}}</div>
                      </div>
                      <div class="clear"></div>
                  </li>
              </ul>
            </div>
            <share></share>
        </div>
    </div>
    <webFooter></webFooter>
</div>
</template>
<script>
import Navi from "components/common/navi";
import SubNavi from "components/media/subnavi";
import Logo from "components/common/logo";
import SpNavi from "components/media/spnavi";
import Share from "components/common/share";
import WebFooter from "components/common/footer";
import apiUrl from "../../utils/api-url";
import interactionApi from "../../api/interaction-api";
export default {
  name: "News",
  components: {
    Navi,
    SubNavi,
    Logo,
    SpNavi,
    Share,
    WebFooter
  },
  data() {
    return {
      videos: [],
      comments: [],
      api_url: ""
    };
  },
  mounted: function() {
    this.getVideos();
    this.getComments();
    this.api_url = apiUrl.url;
  },
  methods: {
    getVideos() {
      var _this = this;
      interactionApi.getVideoList(
        function(response) {
          _this.videos = response;
        },
        function(error) {
          console.error(error);
        }
      );
    },
    getComments() {
      let _this = this;
      interactionApi.getCommentList(
        function(response) {
          _this.comments = response;
        },
        function(error) {
          console.error(error);
        }
      );
    }
  }
};
</script>
<style>
.video-container {
  width: 100%;
}

.video-container .video-item {
  text-align: center;
  float: left;
  padding: 0px 10px;
  width: 30%;
}

.video-container .video-item video {
  width: 100%;
  height: 200px;
}

.clear {
  clear: both;
}
</style>



// WEBPACK FOOTER //
// src/components/media/interaction.vue